export default "__VITE_ASSET__DtirzXiu__"